import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CSListDto } from '@app/apiModules/CSList';

@Component({
  selector: 'app-github-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './github-details.component.html',
  styleUrl: './github-details.component.scss'
})
export class GithubDetailsComponent {
  title: string = "";
  serviceDto: CSListDto;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }



  ngOnInit() {
    this.title = this.data.title || '';
    
    if (this.data.popupcontent) {
      if (typeof this.data.popupcontent === 'string') {
        try {
          this.serviceDto = JSON.parse(this.data.popupcontent);
        } catch (e) {
          console.error('Invalid Service Data:', e);
        }
        this.cdr.detectChanges(); // Force update
      }
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
